import ky from 'ky';

import {AnnotationTelemetryPayload, LabelInstancePaginationResponse} from '~redux/types/images';

import {getOptions} from './api';
import {processFilters} from './filters.utils';
import {ImagesDataPayload} from './images';

const AUTH_API = import.meta.env.VITE_AUTH_API ?? '';

type LabelInstancesPayload = ImagesDataPayload;

export const getLabelInstancesData = (
  projectId: string,
  payload: LabelInstancesPayload,
  areMachinePredictions: boolean,
  reactQuerySignal: AbortSignal | undefined,
  metadata?: MetadataFilters,
): Promise<LabelInstancePaginationResponse> => {
  const {filters, pagination} = payload;

  const endpoint = areMachinePredictions
    ? `${AUTH_API}/label_instances/${projectId}/machine`
    : `${AUTH_API}/label_instances/${projectId}`;

  return ky
    .post(
      endpoint,
      getOptions<LabelInstancesPayload>({
        apiVersion: 3,
        signalId: `getLabelInstancesData-${projectId}`,
        reactQuerySignal,
        data: {
          filters: processFilters(filters, metadata),
          pagination,
        },
      }),
    )
    .json<LabelInstancePaginationResponse>();
};

export const getLabelInstancesIds = (
  projectId: string,
  filters: ImagesDataPayload['filters'],
  pagination: ImagesDataPayload['pagination'],
  reactQuerySignal: AbortSignal | undefined,
  metadata?: MetadataFilters,
): Promise<{ids: string[]}> => {
  return ky
    .post(
      `${AUTH_API}/label_instances/${projectId}/human/ids`,
      getOptions<ImagesDataPayload>({
        apiVersion: 3,
        signalId: `getLabelInstancesIds-${projectId}`,
        reactQuerySignal,
        data: {
          filters: processFilters(filters, metadata),
          pagination,
        },
      }),
    )
    .json<{ids: string[]}>();
};

type CloneLabelInstancesPayload = {
  ids: string[];
  targetLabelId: string;
  targetModelId: string;
  uiContext: string;
  telemetry?: AnnotationTelemetryPayload;
};

export const cloneLabelInstances = (projectId: string, payload: CloneLabelInstancesPayload) => {
  return ky.post(
    `${AUTH_API}/label_instances/${projectId}/human/clone`,
    getOptions({
      signalId: 'cloneLabelInstances',
      data: payload,
    }),
  );
};

type ChangeClassLabelInstancesPayload = {
  ids: string[];
  targetLabelId: string;
  targetModelId: string;
  uiContext: string;
  telemetry?: AnnotationTelemetryPayload;
};

export const changeClassLabelInstances = (projectId: string, payload: ChangeClassLabelInstancesPayload) => {
  return ky.post(
    `${AUTH_API}/label_instances/${projectId}/human/change_class`,
    getOptions({
      signalId: 'changeClassLabelInstances',
      data: payload,
    }),
  );
};

export type DeleteLabelInstancesPayload = {
  ids: string[];
  uiContext: string;
};

export const deleteLabelInstances = (projectId: string, payload: DeleteLabelInstancesPayload) => {
  return ky.post(
    `${AUTH_API}/label_instances/${projectId}/human/delete`,
    getOptions({
      signalId: 'deleteLabelInstances',
      data: payload,
    }),
  );
};
